import { getField, updateField } from 'vuex-map-fields';
import TrunkApi from '@/backend/TrunkApi';
import ProductApi from '@/backend/ProductApi';
import { filter, orderBy } from 'lodash';
import { assignHelper, isTiroirRelevant, openToast } from './helpers';
import router from '../router';


export default {
  namespaced: true,
  state: {
    quoteLoading: false,
    dossierLoading: false,
    shippingOptionDisabled: true,
    configuration: {
      mode: undefined,
      nombre_de_brins: undefined,
      type_de_gaine: undefined,
      extremite_a: undefined,
      extremite_b: undefined,
      longueur_du_lien: undefined,
      tiroir_a_id: undefined,
      tiroir_b_id: undefined,
    },
    options: {
      reflectometrie: false,
      regainage: false,
      chaussette: false,
      livraison: false,
    },
    tiroirs: {
      products: [],
    },
    trunkSimulation: {
      reference: undefined,
      price: undefined,
      id: undefined,
    },
  },
  mutations: {
    updateField,
    setTrunkSimulation: assignHelper('trunkSimulation'),
    setTiroirsOptiques(state, data) {
      state.tiroirs.products = data;
    },
    resetNombreDeBrins(state) {
      state.configuration.nombre_de_brins = undefined;
    },
    resetTypeDeGaine(state) {
      state.configuration.type_de_gaine = undefined;
    },
    resetExtremite(state, side) {
      state.configuration[`extremite_${side}`] = undefined;
    },
    setOption(state, { option, value }) {
      state.options[option] = value;
    },
    setTiroir(state, { extremite, id }) {
      state.configuration[`tiroir_${extremite}_id`] = id;
    },
    resetConfiguration(state) {
      state.configuration.mode = undefined;
      state.configuration.nombre_de_brins = undefined;
      state.configuration.type_de_gaine = undefined;
      state.configuration.extremite_a = undefined;
      state.configuration.extremite_b = undefined;
      state.configuration.longueur_du_lien = undefined;
      state.configuration.tiroir_a_id = undefined;
      state.configuration.tiroir_b_id = undefined;
    },
  },
  actions: {
    simulateTrunkConfiguration({ state, commit }) {
      return TrunkApi.simulate(state.configuration, state.options).then((response) => {
        commit('setTrunkSimulation', response.data);
      });
    },
    fetchTiroirsOptiques({ commit }) {
      return ProductApi.fetchTiroirOptiques().then((response) => {
        commit('setTiroirsOptiques', response.data);
      });
    },
    askQuote({ state, rootState }) {
      state.quoteLoading = true;
      return TrunkApi.askQuote(
        state.trunkSimulation.id,
        rootState.authentication.user.billing_address,
        rootState.authentication.user.siret,
      ).then(() => {
        openToast('Merci ! Votre devis vous sera envoyé par e-mail dans les meilleurs délais.');
        state.quoteLoading = false;
      }).catch(() => {
        openToast('Une erreur est survenue lors de la production de votre devis. Veuillez nous contacter.', 'is-danger');
        state.quoteLoading = false;
      });
    },
    askSummary({ state }) {
      state.dossierLoading = true;
      return TrunkApi.askSummary(state.trunkSimulation.id).then(() => {
        openToast('Merci ! Votre dossier technique vous sera envoyé par e-mail dans les meilleurs délais.');
        state.dossierLoading = false;
      }).catch(() => {
        openToast('Une erreur est survenue lors de la production de votre dossier technique. Veuillez nous contacter.', 'is-danger');
        state.dossierLoading = false;
      });
    },
    getShippingAvailability({ state }) {
      return TrunkApi.shippingAvailable(state.configuration).then((response) => {
        if (response.data === true) {
          state.shippingOptionDisabled = false;
        }
      });
    },
    newConfiguration({ commit }) {
      commit('resetConfiguration');
      router.replace('/uni-trunk/configuration');
    },
  },
  getters: {
    getField,
    relevantTiroirForTrunk(state) {
      return {
        extremiteA: orderBy(
          filter(
            state.tiroirs.products,
            (tiroir) => isTiroirRelevant(
              tiroir, state.configuration.extremite_a, state.configuration.mode,
              state.configuration.nombre_de_brins,
            ),
          ),
          'nombre_de_fibres',
        ).slice(0, 2),
        extremiteB: orderBy(
          filter(
            state.tiroirs.products,
            (tiroir) => isTiroirRelevant(
              tiroir, state.configuration.extremite_b, state.configuration.mode,
              state.configuration.nombre_de_brins,
            ),
          ),
          'nombre_de_fibres',
        ).slice(0, 2),
      };
    },
    getTiroirById: (state) => (id) => filter(state.tiroirs.products, (tiroir) => tiroir.id === id)[0],
    isConfigurationFull({ configuration }) {
      return configuration.mode && configuration.nombre_de_brins
            && configuration.type_de_gaine
            && configuration.extremite_a
            && configuration.extremite_b
            && configuration.longueur_du_lien;
    },
  },
};
